module.exports = __webpack_public_path__ + "static/media/rcbc.03472e56.svg";